<div class="captura-biometrica" *ngIf="exibirTelaCaptura">
    <div class="captura" [ngClass]="{'captura-carregando': exibirTelaCaptura}">
        <div id="box-camera"></div>
    </div>
</div>